import React from 'react'
import { Table, TableRow, TableHead, TableBody, TableCell } from 'transfix-ui/components/Table'
import { makeStyles } from 'transfix-ui/core'
import { Parser, ParserVersion } from '../../types'
import { sortParserVersionsById } from '../../utils'
import { ParserVersionsTableRow } from './ParserVersionsTableRow'

const useStyles = makeStyles({
  tableRow: {
    fontSize: '11px',
  },
})

interface IParserVersionsTableProps {
  onParserVersionSelect: (parserVersion: ParserVersion) => void
  parser: Parser
  onParserVersionDelete: (parserVersion: ParserVersion) => void
  onParserVersionCopy: (parserVersion: ParserVersion) => void
}

export const ParserVersionsTable = ({
  onParserVersionCopy,
  onParserVersionDelete,
  onParserVersionSelect,
  parser,
}: IParserVersionsTableProps) => {
  const classes = useStyles()

  return (
    <Table dataTest='ParserVersionsTable'>
      <TableHead>
        <TableRow tableCellType='th' className={classes.tableRow}>
          <TableCell>ID</TableCell>
          <TableCell>Is Live?</TableCell>
          <TableCell>Was Ever Live?</TableCell>
          <TableCell>Parser Library</TableCell>
          <TableCell>Stupidedi Config</TableCell>
          <TableCell>Tfx12 Config</TableCell>
          <TableCell>Element Conversion Option</TableCell>
          <TableCell>Document Conversion Option</TableCell>
          <TableCell>{}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {sortParserVersionsById(parser.parserVersions).map(parserVersion => (
          <ParserVersionsTableRow
            onParserVersionSelect={onParserVersionSelect}
            onParserVersionDelete={onParserVersionDelete}
            onParserVersionCopy={onParserVersionCopy}
            key={parserVersion.id}
            id={`${parserVersion.id}`}
            isLive={parserVersion.is_live ? 'Yes' : 'No'}
            wasEverLive={parserVersion.was_ever_live ? 'Yes' : 'No'}
            name={`${parserVersion.id}`}
            parserVersion={parserVersion}
          />
        ))}
      </TableBody>
    </Table>
  )
}
